import { api } from '$app/api';

export const getDriverCoverage = garageId =>
  api.get(`/zones/areas?ownerId=${garageId}&ownerType=driver`).then(({ data }) => data[0]);

export function getDriverZoneShapes() {
  return api.get('/zones/areas/all?type=driver').then(res => res.data);
}

export const createDriverCoverage = data => {
  delete data.status;
  return api.post(`/zones/areas`, data)
};

export const updateDriverZone = (ownerId, data) => {
  delete data.status;
  return api.put(`/zones/areas?ownerId=${ownerId}&ownerType=driver`, data);
};
